import React, { type FC } from 'react';
import { Button, Flex } from '@bynder/design-system';
import { useTextElementAlignment } from 'packages/pages/design/hooks/useTextElementAlignment';
import MaybeTooltip from 'packages/common/MaybeTooltip';
import { HORIZONTAL_ALIGNMENTS } from 'packages/pages/editor/RightSideMenu/Shots/Text/TextAlignment/utils';

const ALIGNMENTS = HORIZONTAL_ALIGNMENTS.filter((item) => item.testIdName !== 'justified');

type TextAlignmentsProps = {
    elementId: number;
    disabled: boolean;
};

export const TextAlignments: FC<TextAlignmentsProps> = ({ elementId, disabled }) => {
    const { changeHorizontalAlignment, horizontalAlignment } = useTextElementAlignment(elementId);

    return (
        <Flex gap="1">
            {ALIGNMENTS.map((alignment) => (
                <MaybeTooltip key={alignment.name} hasTooltip={!disabled} content={alignment.name}>
                    <Button
                        isSmall
                        variant="clean"
                        isPressed={alignment.value === horizontalAlignment}
                        isDisabled={disabled}
                        onClick={() => changeHorizontalAlignment(alignment.value)}
                        icon={alignment.icon({})}
                        aria-label={alignment.name}
                    />
                </MaybeTooltip>
            ))}
        </Flex>
    );
};
